import { render, staticRenderFns } from "./TutorialForm.vue?vue&type=template&id=12030ff2&scoped=true&"
import script from "./TutorialForm.vue?vue&type=script&lang=js&"
export * from "./TutorialForm.vue?vue&type=script&lang=js&"
import style0 from "./TutorialForm.vue?vue&type=style&index=0&id=12030ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12030ff2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VStepper,VStepperContent,VStepperStep})
